import { Controller } from "@hotwired/stimulus"

// Force a video to play once it enters the viewport — iOS Safari doesn't always autoplay
// an off-screen video (it stays on its poster). Ported from the LP's inline IIFE.
// One controller instance per <video data-controller="astro-lp-video">. Classic JS only.
export default class extends Controller {
  connect() {
    this.tryPlay()
    if (!("IntersectionObserver" in window)) return
    this.io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) this.tryPlay()
      })
    }, { threshold: 0.2 })
    this.io.observe(this.element)
  }

  disconnect() {
    if (this.io) this.io.disconnect()
  }

  tryPlay() {
    try {
      const p = this.element.play()
      if (p && p.catch) p.catch(() => {})
    } catch (e) {
      // autoplay blocked — leave the poster
    }
  }
}
